import cashBookInstance from '../../cashBook/instance'

const getAcceptInitialBalanceForOldCashBook = () => {
	return cashBookInstance.get('/cash-book/new/initial-balance')
}

export default getAcceptInitialBalanceForOldCashBook
